module.exports = __webpack_public_path__ + "static/poczatek_radia-0ca9961d36bfcae09c5a6cb5e71d4a8a.jpg";